import type { AppRouteWrapperProps } from "./router-app-routes.type";

import { Navigate, useLocation, useSearchParams } from "react-router";

import { usePageModalLocationState } from "@/modules/page-modal";
import { useAuthContext } from "@/services/auth";

export const AppRouteWrapper = ({
  asModal,
  modalParentPath,
  children,
}: AppRouteWrapperProps) => {
  const { hasToken } = useAuthContext();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { backgroundLocation } = usePageModalLocationState();

  if (searchParams.get("error_description")) {
    return <Navigate to={`/sso/error${location.search}`} replace />;
  }

  // If user is not logged in, redirect to login page
  if (!hasToken) {
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  // If page is supposed to be a modal but `pageModal` props do not exist in
  // location object, redirect user to the same page with `pageModal` props:
  // -> `backgroundLocation`: is the page displayed on modal background
  //     and the redirect url on modal close (home page by default)
  // doc: https://v5.reactrouter.com/web/example/modal-gallery
  if (asModal && !backgroundLocation) {
    const parent = modalParentPath ?? "/";
    return (
      <Navigate
        to={location.pathname}
        state={{ pageModal: { backgroundLocation: { pathname: parent } } }}
        replace
      />
    );
  }

  // Otherwise, render the route content
  return children;
};
